import * as React from "react";
const IconSelectBox = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M56 3H8C5.2 3 3 5.2 3 8v48c0 2.8 2.2 5 5 5h48c2.8 0 5-2.2 5-5V8c0-2.8-2.2-5-5-5m3 53c0 1.7-1.3 3-3 3H8c-1.7 0-3-1.3-3-3V8c0-1.7 1.3-3 3-3h48c1.7 0 3 1.3 3 3z" />
    <path d="M44.3 36.6 32 48.7 19.7 36.6c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l13 12.8c.2.2.4.3.7.3s.5-.1.7-.3l13-12.8c.4-.4.4-1 0-1.4s-1-.4-1.4 0M32.7 13.2c-.4-.4-1-.4-1.4 0L18.3 26c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.3 0 .5-.1.7-.3L32 15.3l12.3 12.1c.4.4 1 .4 1.4 0s.4-1 0-1.4z" />
  </svg>
);
export default IconSelectBox;
